import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import { MILES_AND_MORE } from "../../src/loyalty/miles-and-more";
import brandConfig from "./brand.json";

export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "26ca09da-c638-44b3-8370-048d1c5698ed",
  title: "Austrian Airlines",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "en-GB",
  currency: "EUR",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: ["favicon.png"],
  logo: "/assets/images/logo.svg",
  domain: "austrian.coras.io",
  detectLocale: true,
  detectCurrency: true,
  linkedTravelNotice: {
    company: "Austrian Airlines AG",
    companyPossessive: "Austrian Airlines'",
    insolvencyProtectionUrl: {
      default: "https://www.austrian.com/de/en/insolvency-protection",
      "de-DE": "https://www.austrian.com/de/de/insolvenzschutz",
    },
  },
  loyalty: MILES_AND_MORE,
};
